export default __webpack_public_path__ + "media/Time-Management.c07cf1de.svg";